import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';
import{erpplatserver} from '@/utils/baseUrl';


//获取交付列表 (子表保存数据到父表)
export async function getOutputList(params) {
    return post(erpserver+'/scOutput/getOutputList', params, true);
}

//获取产成品列表(新增里面点击+)
export async function getProductList(params) {
    return post(erpserver + '/scOutput/getProductList', params, true);
}

//获取消耗列表
export async function getConsumeList(params) {
     return post(erpserver+'/scOutput/getConsumeList', params, true);
}

 // 保存产出交付
export async function saveOutput(params) {
    return post(erpserver+'/scOutput/saveOutput', params, true);
}


// 作废产出交付
export async function voidOutput(params) {
    return post(erpserver+'/scOutput/voidOutput', params, true);
}

//审核
export async function flowSub(params) {
    return post(erpplatserver+'/flow/flowSub', params, true);
}

// 查看交付单
export async function getOutputDetails(params) {
    return post(erpserver+'/scOutput/getOutputDetails', params, true);
}



//上传图片
export async function upload(params) {
    return post(erpplatserver+'/system/uploadFile',params,false);
}

//上传图片
export async function deleteFileInfo(params) {
    return post(erpplatserver+'/system/deleteFileInfo',params,false);
}